import React, { createContext, useContext, useState } from "react";
import Watch from ".";
export const WatchContex = createContext<any>(null);
const WatchGame = () => {
  const [participants, setParticipants] = useState([]);

  return (
    <WatchContex.Provider value={{ participants, setParticipants }}>
      <Watch />
    </WatchContex.Provider>
  );
};
export default WatchGame;
